class AuditService {
    constructor($http, authenticationService, globalConstants) {
        this.$http = $http;
        this.authenticationService = authenticationService;
        this.token = this.authenticationService.getToken();
        this.globalConstants = globalConstants;
    }

    getAuditsBySubscriptionId(subscriptionId) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/audit/GetAuditLogsForSubscription',
            params: { subscriptionId: subscriptionId}
        });
    }

    getAuditsForUser(subscriptionId) {
        return this.$http({
            method: 'GET',
            url: this.globalConstants.ApiBaseUrl + '/api/audit/GetAuditLogsForUser',
            params: { subscriptionId: subscriptionId}
        });
    }
}

export default AuditService;


// WEBPACK FOOTER //
// ./src/js/services/audit.service.js